module.exports = __webpack_public_path__ + "static/sauces.23087f34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sauces.png
// module id = 563
// module chunks = 89399205538831